import React, { useEffect, useState, useContext } from "react";
import Typography from "@mui/material/Typography";
import LongTextComponent from "../Leads Page/LongTextComponent";
import {
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { DataGrid } from "@mui/x-data-grid";
import {
  useMediaQuery,
  useTheme,
  Chip,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Box,
  Button,
  TablePagination,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DangerousIcon from "@mui/icons-material/Dangerous";
import { useNavigate } from "react-router-dom";
import { LoginContext } from "../LoginPage/LoginContext";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { GridToolbarContainer } from "@mui/x-data-grid";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

function PendingRequestsListComponent({ finalPendingEstimationRow }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const navigate = useNavigate();

  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
    setPage(0); // Reset page to 0 after search
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page changes
  };

  const IconCell = ({ row }) => (
    <div className={`flex`}>
      <Tooltip title="Edit" arrow>
        <IconButton
          style={{
            border: "1px solid",
            borderRadius: "4px",
            padding: "2px",
            width: "24px",
            height: "24px",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#fff",
          }}
          color="primary"
          onClick={() => handleIconClick(row)}
        >
          <EditIcon fontSize="small" color="primary" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Reject" arrow>
        <IconButton
          style={{
            border: "1px solid",
            borderRadius: "4px",
            padding: "2px",
            width: "24px",
            height: "24px",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "4px",
            backgroundColor: "#fff",
          }}
          color="error"
          // onClick={() => handleIconClick(row)}
        >
          <DangerousIcon fontSize="small" color="error" />
        </IconButton>
      </Tooltip>
    </div>
  );

  const handleIconClick = (row) => {
    localStorage.setItem("leadDetails", JSON.stringify(row));
    navigate("/estimateDetails");
  };

  const columnsPending = [
    { field: "sno", headerName: "SNo", width: isMobile ? 30 : 50 },
    {
      field: "EstimationRequirement",
      headerName: "Estimation Requirement",
      width: isMobile ? 180 : 180,
      renderCell: (value) =>
        value === "-" ? (
          <Typography>-</Typography>
        ) : (
          <Typography
            sx={{
              textTransform: "capitalize",
              height: "20px",
              fontWeight: "700",
              fontSize: "0.8rem",
            }}
          >
            {value}
          </Typography>
        ),
    },
    {
      field: "status",
      headerName: "Status",
      width: isMobile ? 180 : 150,
      renderCell: (value) =>
        value === "-" ? (
          <Typography>-</Typography>
        ) : (
          <Chip
            size="small"
            label={value}
            color={getColorForTag(value)}
            sx={{ textTransform: "capitalize", height: "20px", margin: "10px" }}
          />
        ),
    },
    {
      field: "last_estimation_number",
      headerName: "Last Estimation Number",
      width: isMobile ? 180 : 200,
    },
    {
      field: "estimationNumber",
      headerName: "Estimation Number",
      width: isMobile ? 180 : 150,
    },
    {
      field: "estimation_amount",
      headerName: "Estimation Value",
      width: isMobile ? 180 : 150,
    },
    {
      field: "firm_farmer_name",
      headerName: "Firm/Farmer Name",
      width: isMobile ? 180 : 150,
    },
    {
      field: "Estimation_generated_date",
      headerName: "Estimation Generated Date & Time",
      width: isMobile ? 180 : 200,
    },
    {
      field: "Estimation_request_date",
      headerName: "Estimation Request Date & Time",
      width: isMobile ? 180 : 200,
    },
    {
      field: "BdmName",
      headerName: "Requested By",
      width: isMobile ? 180 : 150,
    },
    {
      field: "farmerName",
      headerName: "Farmer Name",
      width: isMobile ? 180 : 150,
    },
    {
      field: "MobNo",
      headerName: "Mobile Number",
      width: isMobile ? 180 : 150,
    },
    { field: "Project", headerName: "Project", width: isMobile ? 180 : 150 },
    {
      field: "StateName",
      headerName: "State Name",
      width: isMobile ? 180 : 150,
    },
    {
      field: "RegionName",
      headerName: "Region Name",
      width: isMobile ? 180 : 150,
    },
    {
      field: "CivilConstructedStarted",
      headerName: "Civil Construction Started",
      width: isMobile ? 180 : 150,
    },
    {
      field: "ShedLength",
      headerName: "Shed Length",
      width: isMobile ? 180 : 150,
    },
    {
      field: "EquipementPlacementLength",
      headerName: "Equipment Placement Length",
      width: isMobile ? 180 : 150,
    },
    {
      field: "ShedWidth",
      headerName: "Shed Width",
      width: isMobile ? 180 : 150,
    },
    { field: "CShape", headerName: "C-Shape", width: isMobile ? 180 : 150 },
    {
      field: "ModalType",
      headerName: "Model Type",
      width: isMobile ? 180 : 150,
    },
    {
      field: "SideWallColumnToColumnGap",
      headerName: "Side Wall Column to Column Gap",
      width: isMobile ? 180 : 250,
    },
    {
      field: "NumberOfSheds",
      headerName: "Number of Sheds",
      width: isMobile ? 180 : 150,
    },
    {
      field: "CurtainRequirment",
      headerName: "Curtain Requirement",
      width: isMobile ? 180 : 150,
    },
    {
      field: "DiselBrooderRequirment",
      headerName: "Diesel Brooder Requirement",
      width: isMobile ? 180 : 150,
    },
    {
      field: "PowerSupply",
      headerName: "Power Supply",
      width: isMobile ? 180 : 150,
    },
    {
      field: "WaterSupply",
      headerName: "Water Available",
      width: isMobile ? 180 : 150,
    },
    {
      field: "Remarks",
      headerName: "Remarks",
      width: isMobile ? 180 : 300,
      renderCell: (value) => (
        <LongTextComponent text={value || ""} maxLength={50} />
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 80,
      renderCell: (value, row) => <IconCell row={row} />,
    },
  ];

  const getColorForTag = (tag) => {
    switch (tag.toLowerCase()) {
      case "pending":
        return "error";
      case "new":
        return "#ff00ff";
      case "revised":
        return "#ff007f";
      default:
        return "default";
    }
  };

  // Filter rows based on the search term
  const filteredRows = finalPendingEstimationRow.filter((row) =>
    Object.values(row).some(
      (value) => value && value.toString().toLowerCase().includes(searchTerm) // Case-insensitive match
    )
  );

  // Slice the rows to match pagination
  const rowsToDisplay = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const exportToExcel = () => {
    // Create a new worksheet
    const worksheetData = finalPendingEstimationRow.map((row) => {
      const rowData = {};
      columnsPending.forEach((column) => {
        // Map each column field to the corresponding row data
        rowData[column.headerName] = row[column.field] || "";
      });
      return rowData;
    });

    // Create a worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Estimation Data");

    // Write the file
    XLSX.writeFile(workbook, "estimation_data.xlsx");
  };

  return (
    <>
      <Paper>
        <IconButton
          onClick={() => exportToExcel()}
          style={{
            border: "1px solid #fff", // Change border color to white for contrast
            borderRadius: "4px",
            // margin: "5px",
            width: "40px", // Increased width for a more comfortable click area
            height: "40px", // Increased height for a more comfortable click area
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#097969",
            color: "#fff",
            transition: "background-color 0.3s, transform 0.2s", // Smooth transition effects
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Add shadow for depth
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#0B9B73"; // Darker shade on hover
            e.currentTarget.style.transform = "scale(1.05)"; // Slightly scale up on hover
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#097969"; // Original color
            e.currentTarget.style.transform = "scale(1)"; // Reset scale
          }}
        >
          <FileDownloadIcon /> {/* Change icon based on state */}
        </IconButton>

        {/* Search Field */}
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search..."
          sx={{ margin: 1, float: "right" }}
          onChange={handleSearchChange}
        />

        <TableContainer
          sx={{
            boxShadow: 2,
            borderRadius: "8px",
          }}
        >
          <Table
            sx={{ minWidth: 650, tableLayout: "fixed" }}
            aria-label="simple table"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                {columnsPending.map((column) => (
                  <TableCell
                    key={column.field}
                    align="center"
                    sx={{
                      backgroundColor: "#EEF0F4",
                      fontSize: "0.8rem",
                      fontWeight: "bold",
                      ...(column.field === "action" && {
                        position: "sticky",
                        right: 0,
                        zIndex: 2,
                        backgroundColor: "#EEF0F4",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      }),
                    }}
                    width={column.width}
                  >
                    {column.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsToDisplay.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columnsPending.map((column) => {
                    const cellValue = row[column.field];
                    return (
                      <TableCell
                        key={column.field}
                        align="center"
                        sx={{
                          ...(column.field === "action" && {
                            position: "sticky",
                            right: 0,
                            zIndex: 1,
                            backgroundColor: "#EEF0F4", // Matches table body background
                          }),
                        }}
                      >
                        {column.field === "Remarks" ? (
                          <LongTextComponent
                            text={cellValue || ""}
                            maxLength={50}
                          />
                        ) : column.field === "action" ? (
                          <IconCell row={row} />
                        ) : column.field === "status" ? (
                          <Chip
                            size="small"
                            label={cellValue}
                            color={getColorForTag(cellValue)}
                            sx={{
                              textTransform: "capitalize",
                              height: "20px",
                              margin: "10px",
                            }}
                          />
                        ) : (
                          <Typography
                            sx={{
                              textTransform: "capitalize",
                              // height: "20px",
                              fontSize: "0.8rem",
                            }}
                          >
                            {cellValue}
                          </Typography>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={finalPendingEstimationRow.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
}

export default PendingRequestsListComponent;
